import React from 'react';
import { createBrowserHistory } from 'history'
import { Route, Switch, Router } from 'react-router'
import PageNotFound from '../components/auth/PageNotFound'
import PrivateRoute from './PrvateRoute'
import Layout from '../components/layout/Layout';
import RoleDetail from '../components/RoleDetail';
import RoleCreate from '../components/RoleCreate';
import AddMemberToRole from '../components/AddMemberToRole';
import Check from '../components/auth/Check';
import Huawei from '../components/Huawei';
// import OldHuawei from '../components/OldHuawei';
import UserList from '../components/user/UserList';
import UserDetail from '../components/user/UserDetail';
import ListDownload from '../components/ListDownload';

export const history = createBrowserHistory({ forceRefresh: true })

const RouteLayout = (cProps) => (
    <Router history={history}>
        <Switch>
            {/* <Route exact path="/huawei" component={OldHuawei} /> */}
            {/* <Route exact path="/another-apk" component={ListDownload} /> */}
            <PrivateRoute path="/apk/latest" props={cProps}>
                <ListDownload></ListDownload>
            </PrivateRoute>
            <Route path="/another-apk" component={ListDownload}/>
            
            <Route exact path="/huawei" component={Huawei} />
            <Route exact path="/check" component={Check} />
            <PrivateRoute exact path="/dashboard" props={cProps} component={Layout} />
            <PrivateRoute exact path="/manage-user" props={cProps} component={Layout} >
                <UserList></UserList>
            </PrivateRoute>
            <PrivateRoute path="/user-info/:id" props={cProps} component={UserDetail} />

            <PrivateRoute exact path="/role-detail/:id" props={cProps} >
                <RoleDetail></RoleDetail>
            </PrivateRoute>
            <PrivateRoute exact path="/create" props={cProps} component={RoleCreate} />
            <PrivateRoute exact path="/add-member-to-role" props={cProps} component={AddMemberToRole} />
            <PrivateRoute exact path="/" props={cProps} component={Layout} />
            {/* <Route path="/susignin" component={ SuSignin } />
            <Route path="/login" props={cProps} component={LoggedIn}></Route>
            <Route path="/callback" props={cProps} component={Callback}></Route>
            <Route path="/refresh" props={cProps} component={Refresh}></Route> */}
            <Route component={PageNotFound} />
            {/* <AuthProvider {...userManagerConfig}> */}
            {/* <Header/> */}

            {/* <PrivateRoute path="/callback" props={cProps} component={Callback}></PrivateRoute> */}

            {/* </AuthProvider> */}

        </Switch>
    </Router>
)

export default RouteLayout

// const config = makeUserManager(userManagerConfig)
// const AppWithAuth = makeAuthenticator({
//     userManager: config,
// })(RouteLayout)

// export const history = createBrowserHistory()

// export default function RouteLayout(props) {
//     return (
//         <Router history={history}>
//             <Switch>
//                 <AppWithAuth exact path="/" component={Auth}/>
//                 <Route component={PageNotFound} />
//                 <Route
//                     path="/callback"
//                     render={routeProps => (
//                         <Callback
//                             onSuccess={user => {
//                                 // `user.state` will reflect the state that was passed in via signinArgs.
//                                 routeProps.history.push('/')
//                             }}
//                             userManager={userManagerConfig}
//                         />
//                     )}
//                 />
//                 <AppWithAuth component={Auth}/>
//             </Switch>
//         </Router>
//     )
// }